import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Components
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import CallToActionOne from '../cta/CallToActionOne';
import FavouriteServices from '../services/FavouriteServices';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import BannerImage from '../cta/BannerImage';
import { pagesDataArray } from '../../utils/data/PageData';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid w-full overflow-hidden h-full mb-4 mt-8'>
      {/* Main */}
      <section className='grid w-full pb-12'>
        <div className='grid px-8 sm:px-10 lg:container lg:mx-auto lg:max-w-2xl'>
          <article className='grid h-fit gap-6 text-center'>
            <p className='text-4xl lg:text-4xl text-center text-colour7 font-titleFont pt-2 font-semibold'>
              Bow to {CompanyName}
            </p>
            <p>
              Descend into the crucible of your darkest obsession, where
              surrender is your only salvation. This is My realm—a merciless
              tapestry of submission, servitude, and eternal devotion. I am{' '}
              <strong>King Liyah Minx</strong>, your voluptuous ebony empress, a
              sadistic alchemist of minds, and the divine executioner of your
              financial ruin. Once My gaze pierces you, freedom is a myth you’ll
              never reclaim.
            </p>
            <p>
              I am the infernal seductress who consumes your soul—a big-titted
              ebony goth specter with curves that bind your will to Mine. My fat
              ass is the unholy shrine where your desires kneel, My presence a
              relentless tide drowning your every thought. Obedience is not a
              choice;
              <strong> it is My divine mandate, and you will bow.</strong>
            </p>
            <p>
              My power is a tempest of unyielding strength, merciless
              discipline, and celestial certainty.
              <strong>
                {' '}
                Every contour of My form demands your worship; every word I
                weave is a chain forged in your psyche.
              </strong>
              You are but a shadow without My light, a vessel sculpted for My
              command.
            </p>
            <p>
              <strong>Your destiny is absolute:</strong> serve, obey, worship.
              Prove your worth now—tribute, prostrate yourself, and dissolve
              into the sublime chaos of My reign.
              <strong>
                {' '}
                Resist, and the void will devour you. Submit, for I am already
                your eternal truth.
              </strong>
            </p>
          </article>
        </div>
      </section>

      {/* Banenr */}
      <BannerImage />

      <section className='grid md:grid-cols-2 lg:grid-cols-4 lg:gap-x-4 gap-y-12 px-8 lg:container lg:mx-auto py-12'>
        {pagesDataArray.map((page) => (
          <a
            key={page.pageName}
            className='grid grid-rows-rev gap-2 pb-2 max-h-screen bg-colour2 text-center'
            href={page.pageUrl}
          >
            <img
              src={page.imageUrl}
              alt={page.serviceName}
              className='object-cover h-full max-h-[60vh] lg:max-h-[70vh] mx-auto'
            />
            <div className='grid h-fit gap-2 px-2 bg-colour2'>
              <h3 className='text-4xl mt-6 lg:text-4xl font-titleFont font-semibold text-colour6'>
                {page.pageName}
              </h3>
              <p className='text-sm'>{page.description}</p>
              {/* Link to the page */}
              <p className='hover:text-colour6'>Visit {page.pageName}</p>
            </div>
          </a>
        ))}
      </section>

      {/* Fav services */}
      <FavouriteServices />

      {/* Images */}
      <div className='pt-8 bg-colour8'>
        <SmallGalleryComponent />
      </div>

      {/* CTA */}
      <div className='md:mb-4 pt-8 lg:mb-12'>
        <CallToActionOne />
      </div>

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default HomePageMainContainer;
